var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BOOKING_APPROVAL_PERMISSION, PERMITTED_OBJECT_TYPE_SPACE, } from '../constants/bookingPermissions';
/**
 * UX-only: whether the current user may approve/reject a reservation for this managed space
 * (`spaces:approve_reservations` on `object_type: space`).
 * On any failure, returns `false` silently (mutations remain authoritative).
 */
export function fetchSpaceApproveReservationPermission(input) {
    return __awaiter(this, void 0, void 0, function () {
        var orgId, managedSpaceId, baseApiUrl, tenantId, post, signal, url, body, res, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    orgId = input.orgId, managedSpaceId = input.managedSpaceId, baseApiUrl = input.baseApiUrl, tenantId = input.tenantId, post = input.post, signal = input.signal;
                    url = "".concat(baseApiUrl, "/organizations/").concat(orgId, "/permitted");
                    body = {
                        permission_operation: BOOKING_APPROVAL_PERMISSION,
                        object_type: PERMITTED_OBJECT_TYPE_SPACE,
                        object_id: managedSpaceId,
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, post(url, body, {
                            headers: {
                                'tenant-id': tenantId,
                                'content-type': 'application/json',
                            },
                            signal: signal,
                        })];
                case 2:
                    res = _b.sent();
                    return [2 /*return*/, Boolean((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.is_permitted)];
                case 3:
                    error_1 = _b.sent();
                    if (error_1 instanceof Error && error_1.name === 'AbortError') {
                        throw error_1;
                    }
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}
